import styled from 'styled-components';
import { SsqImages } from '../images/SsqImages';
import { fontFamilyBold, fontFamilyMedium, fontFamilyRegular } from '../style/fonts';

export const AllPopupWrap = styled.div`
  > div:not(.popup-overlay) {
    background: white;
    z-index: 1002;
    position: fixed;
    width: 36rem;
    height: 64rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 4px;
    padding: 3.2rem;
    color: #2a2c2f;
    &.login-popup {
      height: 70rem;
    }
  }

  /* 로그인 팝업은 하위 팝업(회원가입/비밀번호 초기화/인증메일 발송 등)이 열려도
     '뒤로' 이동 및 입력값 유지를 위해 뒤에 마운트된 채로 남는다. 두 팝업은 화면
     중앙 정렬이라 크기가 같을 때만 완전히 겹쳐 가려지는데, 어느 한쪽에 컨텐츠가
     추가되어 높이가 달라지면 뒤 팝업이 삐져나와 비정상적으로 보인다(예: X 버튼 잘림).
     따라서 하위 팝업이 떠 있는 동안에는 로그인 팝업을 숨겨, 높이 차이와 무관하게
     겹침 문제가 발생하지 않도록 한다. */
  &:has(.Signup_Popup, .Password_Reset_Popup, .Send_Email_Popup) > .login-popup {
    display: none;
  }

  .popup_tit {
    font-size: 2.4rem;
    ${fontFamilyBold};
  }

  .popup_noti {
    font-size: 1.4rem;
    ${fontFamilyRegular};
    margin-top: 1rem;
  }

  .close-button {
    position: absolute;
    right: 2rem;
    top: 2rem;
  }

  .Submit-Button {
    color: white;
    border-radius: 100px;
    width: 100%;
    height: 4.8rem;
    line-height: 4.8rem;
    background: #407edb;
    text-align: center;
    font-size: 1.6rem;
    ${fontFamilyBold};
    cursor: pointer;

    &:hover {
      background: #3b71c4;
    }

    &:active {
      background: #3463ab;
    }
  }

  .popup_img {
    width: 20rem;
    height: 20rem;
    text-align: center;
    background: #f3f6fb;
    display: block;
    border-radius: 100%;
    margin: 4rem auto;

    img {
      margin-top: calc(50% - 5rem);
    }
  }

  .Login_Popup {
    height: auto;
    min-height: 100%;
    display: flex;
    flex-direction: column;

    .login_content_wrap {
      height: 100%;
      width: 100%;
      flex: 1;
      min-height: 48rem;
    }

    .Login-Input-Wrap {
      margin: 4.8rem 0 0.9rem;
      position: relative;
    }

    p {
      font-size: 1.3rem;
      margin-bottom: 0.5rem;
      ${fontFamilyRegular};
    }

    .login-input {
      border: 1px solid #c7d6ea;
      border-radius: 0.4rem;
      width: 100%;
      height: 4rem;
      font-size: 1.3rem;
      margin-bottom: 1.5rem;
      padding: 0 1.2rem;

      ::placeholder {
        ${fontFamilyRegular};
        font-size: 1.2rem;
        color: #7783a1 !important;
      }
    }
  }

  .login-movebutton {
    text-align: center;
    margin: 3rem 0 3.4rem;

    button {
      ${fontFamilyMedium};
      color: #407edb;
      font-size: 1.3rem;

      + button:before {
        content: '';
        display: inline-block;
        width: 0.1rem;
        height: 1.6rem;
        vertical-align: middle;
        background: #c7d6ea;
        margin: 0 1.6rem;
      }
    }
  }

  .login-SNS-tit {
    color: #7783a1;
    text-align: center;
    font-size: 1.3rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    position: relative;

    ::before {
      content: '';
      display: inline-block;
      position: absolute;
      height: 0.1rem;
      width: 100%;
      top: 50%;
      left: 0;
      z-index: -1;
      transform: translateY(-50%);
      background: #c7d6ea;
    }

    div {
      margin: 0 auto 3.2rem;
      width: 14rem;
      height: 2rem;
      background: white;
    }
  }

  .login-Tooltip {
    cursor: default;
    flex-shrink: 0;
    position: absolute;
    z-index: 9;
    width: 8.6rem;
    height: 3.8rem;
    bottom: 5.8rem;
    left: 50%;
    transform: translateX(-50%);

    ::before {
      content: '';
      display: inline-block;
      position: absolute;
      z-index: -1;
      width: 0;
      height: 0;
      bottom: 0;
      right: 3.5rem;
      border-top: 1rem solid #666e7a; /* 화살표 */
      border-left: 0.47rem solid transparent;
      border-right: 0.47rem solid transparent;
    }

    div {
      width: 8.6rem;
      height: 3.1rem;
      padding: 0.5rem 0;
      background: #666e7a;
      border-radius: 0.3rem;
      color: #fff;
      text-align: center;
      font-size: 1.3rem;
      font-style: normal;
      font-weight: 500;
      line-height: 1.5;
      letter-spacing: -0.4px;
    }
  }

  .login-SNS {
    text-align: center;

    > div {
      display: flex;
      justify-content: space-between;
      max-width: 20rem;
      margin: 0 auto;

      > div {
        position: relative;
      }
    }

    a + a {
      margin-left: 2.4rem;
    }

    #naverIdLogin_loginButton {
      background: url(${SsqImages.header.sns.naver()});
      width: 56px;
      height: 57px;
      display: block;
    }

    #naverIdLogin_loginButton img {
      display: none;
    }
  }

  .ls-login {
    color: #7783a1;
    font-size: 1.3rem;
    float: right;
    margin-top: 5rem !important;
    ${fontFamilyRegular};
    text-align: right;
    position: relative;

    .login-Tooltip {
      bottom: 2.1rem;
      width: 100%;
      display: flex;
      justify-content: end;
    }
  }

  .Login-Input-Wrap {
    position: relative;

    .login-Tooltip {
      top: -1.6rem;
      right: 0rem;
      transform: translateX(6.2rem);
    }
  }

  .Signup_Popup {
    height: 100%;
    overflow: auto;
    border-radius: 0.4rem;

    > div {
      position: relative;
      height: 100%;
      min-height: 100%;
      display: flex;
      flex-direction: column;
      background: #fff;
    }

    .popup_tit {
      button {
        margin-right: 0.8rem;
        vertical-align: middle;
      }
    }

    .Signup_top {
      .popup_noti {
        position: relative;

        .requ {
          position: absolute;
          right: 0;
          bottom: 0;
          font-size: 1rem;
          color: #7783a1 !important;

          span:first-child {
            color: #e6003e;
          }
        }
      }
    }

    .Signup_Input {
      padding-top: 1.6rem;
      margin: 0;
      margin-bottom: 6rem;
      padding-right: 2rem;
      overflow-y: auto;
      overflow-x: hidden;

      .input_row {
        margin-bottom: 1.5rem;
        ${fontFamilyRegular};

        p {
          font-size: 1.3rem;
          margin-bottom: 0.4rem;

          span + span {
            color: #e6003e;
          }
        }

        input[type='text'],
        input[type='password'] {
          ${fontFamilyRegular};
          border: 1px solid #c7d6ea;
          border-radius: 0.4rem;
          width: 100%;
          height: 4rem;
          font-size: 1.3rem;
          padding: 0 1.2rem;

          ::placeholder {
            ${fontFamilyRegular};
            font-size: 1.2rem;
            color: #7783a1 !important;
          }

          &:disabled {
            background: rgba(199, 214, 234, 0.5);
            border: 1px solid #c7d6ea;
          }
        }

        .select_wrap {
          select {
            width: 100%;
            height: 4rem;
            line-height: 4rem;
            padding: 0 1.2rem;
            background-position: center right 1.2rem;
          }
        }

        .SingUpInvalidAlert {
          color: #e6003e;
          font-size: 1.2rem;
        }

        .input_memtype02 {
          div + div {
            margin-top: 1.5rem;
          }
        }
      }

      .input_pw_check {
        input {
          &:disabled {
            background: rgba(199, 214, 234, 0.5);
            border: 1px solid #c7d6ea;
          }

          &:enabled {
            background: #fff !important;
          }
        }
      }

      .input_phone {
        > div {
          display: flex;
        }

        .select_wrap {
          min-width: 10.4rem;
          margin-right: 0.8rem;
          display: inline-block;

          select {
            height: 4rem;
            line-height: 4rem;
          }
        }
      }

      .sub_check {
        padding-top: 1.5rem;
        padding-left: 1.5rem;
        border-top: 1px solid #c7d6ea;
      }

      .all_check {
        padding-bottom: 1rem;
      }

      .input_check {
        margin: 0.5rem 0 0;

        > div:first-child button {
          margin-left: 2.4rem;
          margin-top: 0.4rem;
        }

        input[type='checkbox'] {
          display: none;
        }

        input[type='checkbox'] + label {
          display: inline-block;
          width: 1.6rem;
          height: 1.6rem;
          border: 1px solid #c7d6ea;
          border-radius: 2px;
          cursor: pointer;
          vertical-align: middle;
        }

        input[type='checkbox']:checked + label {
          background: #407edb url(${SsqImages.common.icon.CheckboxCheck()}) center center no-repeat;
          border: 1px solid #407edb;
        }

        input[type='checkbox']:checked:disabled + label {
          background: #c7d6ea url(${SsqImages.common.icon.CheckboxCheck()}) center center no-repeat;
          border: 1px solid #c7d6ea;
        }

        .check_txt {
          font-size: 1.3rem;
          ${fontFamilyRegular};
          margin-left: 0.8rem;
        }

        .check_txt_all {
          font-size: 1.5rem;
          ${fontFamilyMedium};
          margin-left: 0.8rem;
        }

        button {
          ${fontFamilyRegular};
          font-size: 1.3rem;
          margin-left: 0.8rem;
          color: #407edb;
          border-bottom: solid 1px #407edb;
        }

        div + div {
          margin-top: 1.5rem;
        }

        .Mailing_Info {
          margin-top: 0.5rem;
          text-align: center;
          font-size: 1rem;
          color: #7783a1;
        }
      }
    }
  }

  .TermsDetail_Wrap {
    z-index: 1003 !important;

    .close-button {
      display: none;
    }

    .popup_tit {
      button {
        margin-right: 0.8rem;
        vertical-align: middle;
      }
    }
  }

  .Login_Icon_Popup {
    .popup_tit {
      button {
        margin-right: 0.8rem;
        vertical-align: middle;
      }
    }
  }

  .Send_Email_Popup {
    .popup_tit {
      button {
        margin-right: 0.8rem;
        vertical-align: middle;
      }
    }

    .email_fail_info {
      font-size: 1.4rem;
      margin-top: 4rem;

      > div:nth-child(2) {
        font-size: 1.3rem;
        color: #7783a1;
        margin: 0.8rem 0;
        ${fontFamilyRegular};
      }

      > button {
        color: #407edb;
        ${fontFamilyBold};
      }
    }
  }

  .Password_Reset_Popup {
    .popup_tit {
      button {
        margin-right: 0.8rem;
        vertical-align: middle;
      }
    }

    .EmailInvalidAlert {
      color: #e6003e;
      font-size: 1.2rem;
    }

    .alert-area {
      height: 2.4rem;
    }

    .email_fail_info {
      font-size: 1.4rem;
      margin-top: 4rem;

      > div:nth-child(2) {
        font-size: 1.3rem;
        color: #7783a1;
        margin: 0.8rem 0;
        ${fontFamilyRegular};
      }

      > button {
        color: #407edb;
        ${fontFamilyBold};
      }
    }

    p {
      font-size: 1.3rem;
      margin-bottom: 0.4rem;
    }

    input[type='text'],
    input[type='password'] {
      ${fontFamilyRegular};
      border: 1px solid #c7d6ea;
      border-radius: 0.4rem;
      width: 100%;
      height: 4rem;
      font-size: 1.3rem;
      padding: 0 1.2rem;

      ::placeholder {
        ${fontFamilyRegular};
        font-size: 1.2rem;
        color: #7783a1 !important;
      }
    }
  }

  @media screen and (max-width: 884px) {
    .Signup_Input {
      overflow-y: auto;
    }

    .Login_Popup {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
    }

    .login_content_wrap {
      min-height: 5rem;
    }

    input[type='password'] {
      font-size: 2rem !important;
    }

    .login-input {
      /* 16/13 = 123% */
      border-radius: 4.92px !important;
      width: 123% !important;
      height: 44.5px !important;
      font-size: 16px !important;
      margin-bottom: 10px !important;
      padding: 0 14.76px !important;

      /* scale by 13/16 = 81% */
      transform: scale(0.81);
      transform-origin: left top;

      ::placeholder {
        font-size: 14px !important;
      }
    }

    .login-Tooltip {
      bottom: 6.6rem;
    }

    .ls-login {
      margin-top: 1.5rem;
      display: flex;
      justify-content: end;
      position: relative;

      .login-Tooltip {
        width: 100%;
        display: flex;
        justify-content: end;
        bottom: 3.1rem;
      }
    }

    .login-movebutton {
      margin: 3rem 0 !important;
    }

    .Signup_Input {
      .input_row {
        margin-bottom: 1rem !important;
      }

      input[type='text']:not(.rs__input),
      input[type='password']:not(.rs__input),
      .select_wrap select {
        border-radius: 4.92px !important;
        width: 123% !important;
        height: 44.5px !important;
        font-size: 16px !important;
        padding: 0 14.76px !important;
        margin-right: -33.333333333%;

        transform: scale(0.81);
        transform-origin: left top;

        ::placeholder {
          font-size: 14px !important;
        }
      }

      .input_phone input[type='text']:not(.rs__input) {
        width: calc(123% - 12.5rem) !important;
      }

      .select_wrap select option {
        font-size: 13px;
      }
    }
  }

  @media screen and (max-width: 763px) {
    > div {
      width: 100% !important;
      height: 100% !important;
      border-radius: 0 !important;
    }

    .Signup_Popup {
      width: 100%;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }

  @media screen and (max-width: 360px), (max-width: 360px) and (max-height: 640px) {
    > div {
      width: 100%;
      display: flex;
      justify-content: center;
    }

    .Signup_Popup {
      overflow-y: auto;
      overflow-x: hidden;
    }

    .popup_tit,
    .popup_noti,
    .input_row * {
      word-break: keep-all;
    }

    .popup_img {
      max-width: 100%;
    }

    .Login_Popup {
      width: 100%;
      height: 100%;
      min-height: 7rem;
      overflow-x: hidden;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .login-SNS {
        margin-bottom: 2rem;
      }
    }

    .Login-Input-Wrap {
      position: relative !important;

      .login-Tooltip {
        top: -1.6rem;
        right: 0;
        bottom: 6.6rem !important;
        transform: translateX(4.5rem);

        div {
          width: auto;
        }
      }
    }

    .Login-Input-Wrap {
      margin: 1rem 0 0 !important;
    }

    .login-movebutton {
      margin: 1.6rem 0 !important;
    }

    .Signup_Popup {
      width: 100%;
      height: 100%;
      position: absolute;
    }

    .TermsDetail_Popup,
    .Password_Reset_Popup,
    .Send_Email_Popup,
    .Login_Icon_Popup,
    .Password_Reset_Popup {
      width: 36rem;
      height: 63rem;
      position: absolute;
      padding: 4rem;
    }

    .Password_Reset_Popup {
      height: 100%;
      width: 100%;
    }

    .Next-default-info {
      position: relative;
    }
  }

  @media screen and (max-height: 770px) {
    > div {
      height: 100%;
      width: 100%;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }

  @media screen and (max-height: 770px) and (max-width: 361px) {
    > div {
      top: 0 !important;
      transform: translate(-50%, 0);
      height: 100%;
      width: 100%;
      overflow-y: auto;
      padding: 0rem;
      overflow-x: hidden;

      &:has(
        .Login_Popup,
        .Signup_Popup,
        .TermsDetail_Popup,
        .Password_Reset_Popup,
        .Send_Email_Popup,
        .Login_Icon_Popup,
        .Password_Reset_Popup
      ) {
        top: 50% !important;
        padding: 0 !important;
      }
    }

    .Login_Popup,
    .TermsDetail_Popup,
    .Password_Reset_Popup,
    .Send_Email_Popup,
    .Login_Icon_Popup,
    .Password_Reset_Popup {
      height: 63rem;
      width: 36rem;
      min-height: auto !important;
      position: absolute;
      padding: 4rem 3rem 4rem 3rem;
    }

    .Login_Popup {
      width: 100%;
      min-height: 70rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .Signup_Popup {
        position: absolute;
        height: 63rem;
        width: 36rem;

        .Signup_Input {
          overflow-y: auto;
        }
      }

      .Login_Popup,
      .Password_Reset_Popup,
      .LoginFail_Popup,
      .Signup_Popup {
        height: 100%;
        width: 100%;
      }
    }
  }

  @media screen and (max-width: 360px) and (max-width: 280px) {
    .Signup_Input {
      flex: 0 0 44rem !important;
      height: 44rem;
    }

    .ls-login {
      margin-top: 3rem;
      position: relative;
      right: 0;
      bottom: 0;
      padding-bottom: 1rem;

      .login-Tooltip {
        bottom: 3.1rem;
      }
    }
  }
`;
